import { CreateOfferRequest, OffersResponse } from '@/@types/Products/Offers';
import { formatOfferOptionLabel } from '@/utils/formatOfferRecurringLabel';
import { api } from './api';

export class OffersService {
  static async createOffer({
    productId,
    data,
  }: {
    productId: string;
    data: CreateOfferRequest;
  }) {
    return await api.post(`/v1/products/${productId}/offers`, data);
  }

  static async editOffer({
    productId,
    offerId,
    data,
  }: {
    productId: string;
    offerId: string;
    data: CreateOfferRequest;
  }) {
    await api.put(`/v1/products/${productId}/offers/${offerId}`, data);
  }

  static async activateOffer({
    productId,
    offerId,
  }: {
    productId: string;
    offerId: string;
  }) {
    await api.patch(`/v1/products/${productId}/offers/${offerId}/activate`);
  }

  static async deactivateOffer({
    productId,
    offerId,
  }: {
    productId: string;
    offerId: string;
  }) {
    await api.patch(`/v1/products/${productId}/offers/${offerId}/deactivate`);
  }

  static async getOffers({
    productId,
    page,
  }: {
    productId: string;
    page: number;
  }): Promise<OffersResponse> {
    const response = await api.get(
      `/v1/products/${productId}/offers?page=${page}`
    );
    return response.data;
  }

  static async getUpsellsOffers({
    productId,
    q,
  }: {
    productId: string;
    q: string;
  }) {
    const params = new URLSearchParams();
    if (q) {
      params.append('q', q);
    }
    const response = await api.get(
      `/v1/products/${productId}/offer-funnels/search?${params.toString()}`
    );
    const offers = response.data.data.map((offer) => ({
      label: formatOfferOptionLabel(offer),
      value: offer.id,
      price: offer.price_formatted,
    }));
    return offers;
  }

  static async getOffersToCreation({ productId, q }: { productId: string; q?: string }) {
    const response = await api.get(`/v1/products/${productId}/offer-bumps/selectOffers${q && q.length > 2 ? `?q=${encodeURIComponent(q)}` : ""}`);
    const offers = response.data.data.map((offer) => ({
      label: formatOfferOptionLabel(offer),
      value: offer.id,
    }));
    return offers;
  }

  static async deleteOffer({
    offerId,
    productId,
  }: {
    productId: string;
    offerId: string;
  }) {
    await api.delete(`/v1/products/${productId}/offers/${offerId}`);
  }

  static async getAllOffers(query?: string): Promise<any> {
    const params = new URLSearchParams();
    if (query) {
      params.append('q', query);
    }
    const response = await api.get(`/v1/offers/all?${params.toString()}`);
    const offers = response.data.data.map((product: any) => ({
      value: product.id,
      label: product.name,
    }));
    return offers;
  }
}
